import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ReactPaginate from "react-paginate";

import { handleParamsPage } from "redux/taxAnalises";

import { Totals } from "./Header/CardsTotals";

import PagesHeaders from "components/Structure/DataTable/pagesHeader";

import { FilterAdvanced } from "./Header/Filter/FilterAdvanced";

import { ActionsHeader } from "./Header/ActionsHeader";
import { Filter } from "react-feather";

import { TaxAnalysisListDefault } from "./DefaultList";
import { useArquivaMix } from "hooks";
import { ArquivaMixListAnaliseFiscal } from "../../ArquivaMix/AnaliseFiscal/list";
import { IgnoredProducts } from "./ProductsIgnored";
import { useIsUserMix } from "hooks/useIsUserMix";

export const CustomPagination = ({ totalPages }) => {
  const { params } = useSelector(state => state.taxAnalises);

  const dispatch = useDispatch();

  const handlePagination = page =>
    dispatch(handleParamsPage({ page: page.selected + 1 }));

  return (
    <ReactPaginate
      nextLabel=""
      breakLabel="..."
      previousLabel=""
      pageCount={totalPages}
      activeClassName="active"
      breakClassName="page-item"
      pageClassName={"page-item"}
      breakLinkClassName="page-link"
      nextLinkClassName={"page-link"}
      pageLinkClassName={"page-link"}
      nextClassName={"page-item next"}
      previousLinkClassName={"page-link"}
      previousClassName={"page-item prev"}
      onPageChange={page => handlePagination(page)}
      forcePage={params?.page !== 0 ? params?.page - 1 : 0}
      containerClassName={"pagination react-paginate justify-content-end p-1"}
    />
  );
};

export const TaxAnalysisListing = () => {
  const { dataProductsLength } = useSelector(state => state.taxAnalises);
  const { isArquivaMix } = useArquivaMix();
  const isUserMix = useIsUserMix();

  return (
    <div className="mt-1">
      <Totals />
      <PagesHeaders
        title={``}
        isToggle
        titleFilter={<Filter size={15} />}
        childrenAction={<ActionsHeader disabledBtn={!dataProductsLength} />}
        childrenToogle={<FilterAdvanced />}
      />
      {isArquivaMix ? (
        <ArquivaMixListAnaliseFiscal />
      ) : (
        <>
          <TaxAnalysisListDefault />
          {isUserMix && <IgnoredProducts />}
        </>
      )}
    </div>
  );
};
